module.exports = __webpack_public_path__ + "img/hr-tree-01-e-trunk.83c3dfac.png";